import React, { Component } from 'react'
import defaultBcg from '../images/room-1.jpeg'
import Banner from './banner'
import Hero from './hero'
import { RoomContext } from '../context'
import { Link, useParams } from 'react-router-dom'
import StyledHero from './styledHero'
import { useNavigate } from 'react-router-dom';
export default class SingleRoom extends Component {

    constructor(props){
        super(props)
        // const history = useNavigate()
        // const { slug } = this.props;
        // let { slug } = useParams();
        // let params = (new URL(window.location)).searchParams;
        // let slug = params.get('slug')
        const  params = new URLSearchParams(new URL(window.location).search);
        let slug = params.get('name')
        console.log('props params >>>',slug);
        this.state = {
            slug:slug,
            defaultBcg
        }
    }

    static contextType = RoomContext

    // componentDidMount(){

    // }
    
    render() {
        const {getRoom} = this.context
        const room = getRoom(this.state.slug)
        console.log(room);
        if(!room){
            return( 
                <Hero>
                    
                <div className='error'>
                    <h3>No such room could be found</h3>
                    <Link to='/rooms' className='btn-primary'>
                        Back to rooms
                    </Link>
                </div>
                
                </Hero>
            )
        }else{
            // can leave it without the else statement though
            const {name, description, capacity, size, price, extras, brakefast, pets, images} = room
            const [mainImg, ...defaultImg] = images
            return (
                <div>
                    <StyledHero img={mainImg || this.defaultBcg}>
                        <Banner title={`${name} room`}>
                            <Link to='/rooms' className='btn-primary'>
                                Back to rooms
                            </Link>
                        </Banner>
                    </StyledHero>
                    <section className='single-room'>
                        <div className='single-room-images'>
                           {defaultImg.map((item,index)=>{
                               return <img key={index} src={item} alt={name} />
                           })}
                        </div>
                        <div className='single-room-info'>
                             <article className='desc'>
                                <h3>Details</h3>
                                <p>{description}</p>
                             </article>
                             <article className='info'>
                                <h3>info</h3>
                                <h6>price : ${price}</h6>
                                <h6>size : ${size} SQFT</h6>
                                <h6>max capacity : {capacity > 1 ? `${capacity} people`: `${capacity} person`} SQFT</h6>
                                <h6>size : {pets ? 'pets allowed' : 'no pets allowed'}</h6>
                                <h6>{brakefast ? 'brakefast not included' :'free brakefast included'}</h6>
                             </article>
                        </div>
                    </section>
                    <section className='room-extras'>
                        <h6>{extras}</h6>
                        <ul className='extras'>
                             {extras.map((item,index)=>{
                                 return <li key={index}>
                                     {item}
                                 </li>
                             })}
                        </ul>
                    </section>
                </div>
            )
        }
    }
}
